import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./BetMessage.module.scss";
import { BetCardAlert } from "sections/Betting/Betslip/components/BetCardAlert";
import { Clamp } from "components/Clamp";
import type { VariantProps } from "class-variance-authority";
import type { alertVariants } from "components/Alert/Alert";

export type BetMessageVariant = VariantProps<typeof alertVariants>["variant"];

type BetMessageProps = {
  type?: BetMessageVariant;
  message: string;
  actionText?: string;
  action?: () => void;
};

export const BetMessage = ({
  type,
  message,
  actionText,
  action,
}: BetMessageProps) => {
  const { t } = useTranslation();

  return (
    <BetCardAlert
      variant={type}
      clamp={
        actionText || action ? (
          <Clamp
            className={styles.clickable}
            onClick={action ?? (() => {})}
            variant={type}
          >
            {actionText ?? "Got It"}
          </Clamp>
        ) : null
      }
    >
      {t(message, message)}
    </BetCardAlert>
  );
};
